/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function ChevronDownIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "chevron-down", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M17 10L12.5 15.5L8 10", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(ChevronDownIcon);
export default ForwardRef;
//# sourceMappingURL=chevronDownIcon.js.map